import { useMutation } from '@tanstack/react-query';

import OpenNotification from 'src/app/components/antd/OpenNotification';

import { apiCancellationFunnels } from '../../api';
import { videoResponseFactory } from '../../utils/videoFunnelsPageFactory';

export function useTryToRequestVideoPage() {
  const { mutateAsync } = useMutation({
    mutationFn: async (id: string) => {
      const response =
        await apiCancellationFunnels.tryToRequestGetOneCancellationFunnelPage(
          id
        );

      const factory = videoResponseFactory(response.data);

      return factory;
    },
    onError: () => {
      OpenNotification(
        true,
        'Erro ao solicitar dados de Vídeo',
        'Ocorreu um erro ao solicitar dados de Vídeo, por favor tente novamente mais tarde.'
      );
    },
  });

  return {
    tryToRequestVideoPage: mutateAsync,
  };
}
